import {Button, DialogContent, Stack, Typography, useTheme} from '@mui/material';
import {IconIllustration, Modal} from 'presentation/components';
import Icon from 'presentation/icons';
import {translations} from 'presentation/translations-new';
import React from 'react';
import {useNavigate} from 'react-router-dom';
import {RefundEnum} from 'presentation/constants';
import {ConclusionModalProps} from './types';
import {RefundVariantEnum} from '../../constants/refundVariantEnum';

const {
	headerTitle,
	title,
	additionalDocumentsDescription,
	previewRefundDescription,
	protocolDescription,
	refundDescription,
	buttonText,
} = translations['pt-br'].privateFlow.refund.conclusionModal;

export function ConclusionModal({
	protocol,
	variant,
	open,
	setOpen,
	modalDataTagId,
	btnDataTagId,
}: ConclusionModalProps) {
	const {colors} = useTheme();
	const navigate = useNavigate();

	const handleCloseModal = () => {
		setOpen(false);
		navigate(RefundEnum.REFUND, {replace: true});
	};

	const getDescription = () => {
		if (variant === RefundVariantEnum.PREVIEW) return previewRefundDescription;
		if (variant === RefundVariantEnum.ADDITIONAL_DOCUMENTS)
			return additionalDocumentsDescription;

		return refundDescription;
	};

	return (
		<Modal.Root open={open} fullScreen={false}>
			<Modal.Header
				title={headerTitle}
				disableClose
				sx={{height: '64px', justifyContent: 'center'}}
				modalDataTagId={modalDataTagId}
			/>
			<DialogContent sx={{p: 'initial'}}>
				<Stack alignItems="center" gap={2} padding={3}>
					<IconIllustration variant={'success'} />

					<Typography variant="h6" textAlign="center">
						{title}
					</Typography>

					<Typography variant="body1" textAlign="center">
						{getDescription()}
					</Typography>

					<Stack direction="row" gap={1} my={1}>
						<Icon
							name="assignment-filled"
							color={colors.brand.primary.blue}
							size={20}
						/>
						<Stack>
							<Typography variant="body1" color={'text.secondary'}>
								{protocolDescription}
							</Typography>
							<Typography variant="body1">{protocol}</Typography>
						</Stack>
					</Stack>
				</Stack>
			</DialogContent>

			<Modal.Footer>
				<Button
					data-tag-id={btnDataTagId}
					onClick={handleCloseModal}
					variant="contained"
					size="large"
					fullWidth>
					{buttonText}
				</Button>
			</Modal.Footer>
		</Modal.Root>
	);
}
